




















import { Component, Vue, Prop } from 'vue-property-decorator';

const Paginate = require('vuejs-paginate');

@Component({
  components: {
    Paginate,
  },
})
export default class PaginationComponent extends Vue {
  @Prop()
  private value!: number;

  @Prop({ required: true })
  private count!: number;

  @Prop()
  private limit!: number;

  private changePage(page: number) {
    this.$emit('input', page);
    this.$emit('change-page', page);
  }

  get totalPages() {
    return Math.ceil(this.count / this.limit);
  }
}
